/**
 * To use, add `dataAdapter: $.fn.select2.amd.require("select2/data/cacheableAjaxAdapter"),` to the root select2 options,
 * and import this file.
 */
$.fn.select2.amd.define("select2/data/cacheableAjaxAdapter", [
        "select2/data/ajax", "select2/defaults", "select2/utils",
        "select2/data/maximumInputLength", "select2/data/maximumSelectionLength",
        "select2/data/unccMinimumInputLength", "select2/data/tags", "select2/data/tokenizer",
    ],
    function (AjaxAdapter, Defaults, Utils, MaximumInputLength, MaximumSelectionLength, UnccMinimumInputLength, Tags, Tokenizer) {
        function CacheableAjaxAdapter($element, options) {
            this.__cache = {};
            CacheableAjaxAdapter.__super__.constructor.call(this, $element, options);
        }

        Utils.Extend(CacheableAjaxAdapter, AjaxAdapter);

        CacheableAjaxAdapter.prototype._applyDefaults = function (options) {
            const defaults = CacheableAjaxAdapter.__super__._applyDefaults(options);

            defaults.transport = (params, success, failure) => {
                const key = JSON.stringify(params);
                let $request;

                if (typeof this.__cache[key] !== "undefined") {
                    $request = this.__cache[key];
                } else {
                    this.__cache[key] = $request = $.ajax(params);
                }

                $request.then(success);
                $request.fail(() => {
                    // If we failed the request, we need to remove it from the
                    // cache, so we can try again later.
                    this.__cache[key] = undefined;
                });
                $request.fail(failure);

                return $request;
            };

            return defaults;
        };

        // This works around a short-coming in select2 where custom adapters
        // do not get any decorators applied.
        const defaultsApply = Defaults.apply;
        Defaults.apply = function(options) {
            options = defaultsApply.call(this, options);

            if (options.minimumInputLength > 0) {
                options.dataAdapter = Utils.Decorate(
                    options.dataAdapter,
                    UnccMinimumInputLength
                );
            }

            if (options.maximumInputLength > 0) {
                options.dataAdapter = Utils.Decorate(
                    options.dataAdapter,
                    MaximumInputLength
                );
            }

            if (options.maximumSelectionLength > 0) {
                options.dataAdapter = Utils.Decorate(
                    options.dataAdapter,
                    MaximumSelectionLength
                );
            }

            if (options.tags) {
                options.dataAdapter = Utils.Decorate(options.dataAdapter, Tags);
            }

            if (options.tokenSeparators != null || options.tokenizer != null) {
                options.dataAdapter = Utils.Decorate(
                    options.dataAdapter,
                    Tokenizer
                );
            }

            return options;
        };

        return CacheableAjaxAdapter;
    });
